import classnames from "classnames";
import React from "react";

interface Props extends Pick<React.ImgHTMLAttributes<HTMLImageElement>, "alt" | "className" | "height" | "width"> {
  type: "light" | "dark";
}

const defaultAlt = "TravelLocal is ATOL member 11445 - book with confidence.";

/**
 * TravelLocal's ATOL logo.
 * 
 * We have to display it on every page of our marketing site as part of the terms of our ATOL licence.
 * 
 * @status stable
 */
export const AtolLogo: React.FC<Props> = ({ type, alt, className, ...rest }) => {
  const imgClassName = classnames("lazyload", "atol-logo", `atol-logo--${type}`, className);
  const altText = alt ?? defaultAlt;
  const path = `/images/logos/ATOL_logo_${type}.svg`;

  return (
    <img {...rest} className={imgClassName} alt={altText} title={altText} data-src={path} />
  );
};

AtolLogo.defaultProps = {
  alt: defaultAlt
};
